import { Component, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./languages.component.scss'],
})
export class LanguagesComponent {
  languageName = output<string>();

  getLang(name: string): void {
    this.languageName.emit(name);
  }
}
